// extracted by mini-css-extract-plugin
export default {"thanks_container":"seller_register_thanks_container__0S7GE","thanks_statement":"seller_register_thanks_statement__Z-z+p","thanks_button":"seller_register_thanks_button__14Q6P"};